import { httpGet } from './http';
import { transformReport, BackendReport, FrontendReport } from './transform';

export type { FrontendReport };

// 获取所有报告
export async function getPublicReports(): Promise<FrontendReport[]> {
  const response = await httpGet<BackendReport[]>('/public/reports');
  return (response || []).map(transformReport);
}

// 获取报告详情
export async function getReportById(id: number): Promise<FrontendReport | null> {
  try {
    const response = await httpGet<BackendReport>(`/public/reports/${id}`);
    return transformReport(response);
  } catch {
    return null;
  }
}
